import PlanCategories from "@/mixins/PlanCategories";

const quoteDataRestore = function (quoteModule, payload) {
  let covDates = {
    start_date: payload.coverage_start_date,
    end_date: payload.coverage_end_date,
  };
  let trav = payload.traveler_details.map((t, i) => {
    let traveler = t;
    traveler.ref = `traveler${i}`;
    return traveler;
  });

  let destStates = payload.destination.map((d) => {
    return { isValid: true };
  });
  let travStates = payload.traveler_details.map((t) => {
    return { isValid: true };
  });

  switch (parseInt(payload.category_id)) {
    case PlanCategories.IMMIGRANT.ID:
      quoteModule.quote_data.current_category = PlanCategories.IMMIGRANT.TYPE;
      quoteModule.quote_data.immigrant.destination = payload.destination[0];
      quoteModule.quote_data.immigrant.destination_state = payload.state;
      quoteModule.quote_data.immigrant.travelers = trav;
      quoteModule.quote_data.immigrant.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.IMMIGRANT.TYPE;

      quoteModule.quote_data_states.destination.immigrant.isValid = true;
      quoteModule.quote_data_states.destination.immigrant.data = destStates;

      quoteModule.quote_data_states.traveler.immigrant.isValid = true;
      quoteModule.quote_data_states.traveler.immigrant.data = travStates;

      quoteModule.quote_data_states.coverage_dates.immigrant.isValid = true;
      break;
    case PlanCategories.J1.ID:
      quoteModule.quote_data.current_category = PlanCategories.J1.TYPE;
      quoteModule.quote_data.j1.destination = payload.destination[0];
      quoteModule.quote_data.j1.destination_state = payload.state;
      quoteModule.quote_data.j1.travelers = trav;
      quoteModule.quote_data.j1.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category = PlanCategories.J1.TYPE;

      quoteModule.quote_data_states.destination.j1.isValid = true;
      quoteModule.quote_data_states.destination.j1.data = destStates;

      quoteModule.quote_data_states.traveler.j1.isValid = true;
      quoteModule.quote_data_states.traveler.j1.data = travStates;

      quoteModule.quote_data_states.coverage_dates.j1.isValid = true;
      break;
    case PlanCategories.SCHENGEN.ID:
      quoteModule.quote_data.current_category = PlanCategories.SCHENGEN.TYPE;
      quoteModule.quote_data.schengen.destinations = payload.destination.map(
        (d, i) => {
          return {
            ref: `destination${i}`,
            value: d,
          };
        }
      );
      quoteModule.quote_data.schengen.travelers = trav;
      quoteModule.quote_data.schengen.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.SCHENGEN.TYPE;

      quoteModule.quote_data_states.destination.schengen.isValid = true;
      quoteModule.quote_data_states.destination.schengen.data = destStates;

      quoteModule.quote_data_states.traveler.schengen.isValid = true;
      quoteModule.quote_data_states.traveler.schengen.data = travStates;

      quoteModule.quote_data_states.coverage_dates.schengen.isValid = true;
      break;
    case PlanCategories.STUDENT.ID:
      quoteModule.quote_data.current_category = PlanCategories.STUDENT.TYPE;
      quoteModule.quote_data.student.destination = payload.destination[0];
      quoteModule.quote_data.student.destination_state = payload.state;
      quoteModule.quote_data.student.travelers = trav;
      quoteModule.quote_data.student.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.STUDENT.TYPE;

      quoteModule.quote_data_states.destination.student.isValid = true;
      quoteModule.quote_data_states.destination.student.data = destStates;

      quoteModule.quote_data_states.traveler.student.isValid = true;
      quoteModule.quote_data_states.traveler.student.data = travStates;

      quoteModule.quote_data_states.coverage_dates.student.isValid = true;
      break;
    case PlanCategories.TRIP.ID:
    case PlanCategories.CFAR.ID:
      quoteModule.quote_data.current_category = PlanCategories.TRIP.TYPE;
      quoteModule.quote_data.trip.destinations = payload.destination.map(
        (d, i) => {
          return {
            ref: `destination${i}`,
            value: d,
          };
        }
      );
      let totalTripCost = 0;
      quoteModule.quote_data.trip.travelers = trav.map((t) => {
        t.residence_country = payload.residency;
        t.residence_state = payload.state;
        t.trip_cost = t.tripCost;

        totalTripCost += parseInt(t.tripCost) || 0;
        return t;
      });

      quoteModule.quote_data.trip.coverage_dates = covDates;

      quoteModule.quote_data.trip.trip_deposit_date = payload.trip_deposit_date;
      quoteModule.quote_data.trip.trip_deposit_date_user_selected =
        !!payload.trip_deposit_date;

      // Set total trip cost from payload or calculate from per-traveler costs
      if (payload.total_trip_cost !== undefined) {
        quoteModule.quote_data.trip.total_trip_cost = payload.total_trip_cost;
      } else {
        quoteModule.quote_data.trip.total_trip_cost = totalTripCost;
      }

      quoteModule.quote_data.trip.has_quote_generated = true;

      quoteModule.quote_data_states.current_category = PlanCategories.TRIP.TYPE;

      quoteModule.quote_data_states.destination.trip.isValid = true;
      quoteModule.quote_data_states.destination.trip.data = destStates;

      quoteModule.quote_data_states.traveler.trip.isValid = true;
      quoteModule.quote_data_states.traveler.trip.data = travStates;

      quoteModule.quote_data_states.coverage_dates.trip.isValid = true;
      break;
    case PlanCategories.VISITOR.ID:
      quoteModule.quote_data.current_category = PlanCategories.VISITOR.TYPE;
      quoteModule.quote_data.visitor.destinations = payload.destination.map(
        (d, i) => {
          return {
            ref: `destination${i}`,
            value: d,
          };
        }
      );
      quoteModule.quote_data.visitor.travelers = trav;
      quoteModule.quote_data.visitor.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.VISITOR.TYPE;

      quoteModule.quote_data_states.destination.visitor.isValid = true;
      quoteModule.quote_data_states.destination.visitor.data = destStates;

      quoteModule.quote_data_states.traveler.visitor.isValid = true;
      quoteModule.quote_data_states.traveler.visitor.data = travStates;

      quoteModule.quote_data_states.coverage_dates.visitor.isValid = true;
      break;
    case PlanCategories.PREEX.ID:
      quoteModule.quote_data.current_category = PlanCategories.PREEX.TYPE;
      quoteModule.quote_data.preex.destinations = payload.destination.map(
        (d, i) => {
          return {
            ref: `destination${i}`,
            value: d,
          };
        }
      );
      quoteModule.quote_data.preex.travelers = trav;
      quoteModule.quote_data.preex.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.PREEX.TYPE;

      quoteModule.quote_data_states.destination.preex.isValid = true;
      quoteModule.quote_data_states.destination.preex.data = destStates;

      quoteModule.quote_data_states.traveler.preex.isValid = true;
      quoteModule.quote_data_states.traveler.preex.data = travStates;

      quoteModule.quote_data_states.coverage_dates.preex.isValid = true;
      break;
    case PlanCategories.ADDND.ID:
      quoteModule.quote_data.current_category = PlanCategories.ADDND.TYPE;
      quoteModule.quote_data.addnd.destinations = payload.destination.map(
        (d, i) => {
          return {
            ref: `destination${i}`,
            value: d,
          };
        }
      );
      quoteModule.quote_data.addnd.travelers = trav;
      quoteModule.quote_data.addnd.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.ADDND.TYPE;

      quoteModule.quote_data_states.destination.addnd.isValid = true;
      quoteModule.quote_data_states.destination.addnd.data = destStates;

      quoteModule.quote_data_states.traveler.addnd.isValid = true;
      quoteModule.quote_data_states.traveler.addnd.data = travStates;

      quoteModule.quote_data_states.coverage_dates.addnd.isValid = true;
      break;
    case PlanCategories.MEDEVAC.ID:
      quoteModule.quote_data.current_category = PlanCategories.MEDEVAC.TYPE;
      quoteModule.quote_data.medevac.destinations = payload.destination.map(
        (d, i) => {
          return {
            ref: `destination${i}`,
            value: d,
          };
        }
      );
      quoteModule.quote_data.medevac.travelers = trav;
      quoteModule.quote_data.medevac.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.MEDEVAC.TYPE;

      quoteModule.quote_data_states.destination.medevac.isValid = true;
      quoteModule.quote_data_states.destination.medevac.data = destStates;

      quoteModule.quote_data_states.traveler.medevac.isValid = true;
      quoteModule.quote_data_states.traveler.medevac.data = travStates;

      quoteModule.quote_data_states.coverage_dates.medevac.isValid = true;
      break;
    case PlanCategories.OPTSTUDENT.ID:
      quoteModule.quote_data.current_category = PlanCategories.OPTSTUDENT.TYPE;
      quoteModule.quote_data.optstudent.destination = payload.destination[0];
      quoteModule.quote_data.optstudent.destination_state = payload.state;
      quoteModule.quote_data.optstudent.travelers = trav;
      quoteModule.quote_data.optstudent.coverage_dates = covDates;

      quoteModule.quote_data_states.current_category =
        PlanCategories.OPTSTUDENT.TYPE;

      quoteModule.quote_data_states.destination.optstudent.isValid = true;
      quoteModule.quote_data_states.destination.optstudent.data = destStates;

      quoteModule.quote_data_states.traveler.optstudent.isValid = true;
      quoteModule.quote_data_states.traveler.optstudent.data = travStates;

      quoteModule.quote_data_states.coverage_dates.optstudent.isValid = true;
      break;
    case PlanCategories.CRUISE.ID:
      quoteModule.quote_data.current_category = PlanCategories.CRUISE.TYPE;
      quoteModule.quote_data.cruise.destinations = payload.destination.map(
        (d, i) => {
          return {
            ref: `destination${i}`,
            value: d,
          };
        }
      );
      let totalCruiseCost = 0;
      quoteModule.quote_data.cruise.travelers = trav.map((t) => {
        t.residence_country = payload.residency;
        t.residence_state = payload.state;
        t.trip_cost = t.tripCost;
        totalCruiseCost += parseInt(t.tripCost) || 0;
        return t;
      });
      quoteModule.quote_data.cruise.coverage_dates = covDates;

      quoteModule.quote_data.cruise.trip_deposit_date =
        payload.trip_deposit_date;
      quoteModule.quote_data.cruise.trip_deposit_date_user_selected =
        !!payload.trip_deposit_date;

      // Set total trip cost from payload or calculate from per-traveler costs
      if (payload.total_trip_cost !== undefined) {
        quoteModule.quote_data.cruise.total_trip_cost = payload.total_trip_cost;
      } else {
        quoteModule.quote_data.cruise.total_trip_cost = totalCruiseCost;
      }

      quoteModule.quote_data.cruise.has_quote_generated = true;

      quoteModule.quote_data_states.current_category =
        PlanCategories.CRUISE.TYPE;

      quoteModule.quote_data_states.destination.cruise.isValid = true;
      quoteModule.quote_data_states.destination.cruise.data = destStates;

      quoteModule.quote_data_states.traveler.cruise.isValid = true;
      quoteModule.quote_data_states.traveler.cruise.data = travStates;

      quoteModule.quote_data_states.coverage_dates.cruise.isValid = true;
      break;
  }

  return quoteModule;
};
export default quoteDataRestore;
